import { useEffect, useState } from 'react'

import { DatePicker, Input } from 'antd'
import dayjs from 'dayjs'

import { Personal } from '@/components/Personal'
import { ISessionHistoryItem } from '@/httpRequest/modules/mesperyIm/sessionHistory'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import { useUserAtom } from '@/store/user'
import ArrowIcon from '@img/components/arrow.png'
import DelSrc from '@img/components/del.png'
import personal from '@img/personal/Default@3x.png'

import useSessionListUsers from '../hooks/useSessionListUsers'
import styles from '../message.module.less'
import { EMessageType } from '../types/message'

export const ChatRecords = () => {
  const { setChatRecords, chatRecordsData } = useMessageAtom()
  const [showDate, setShowData] = useState<ISessionHistoryItem[]>()
  const [searchVal, setSearchVal] = useState<string>()
  const [searchDate, setSearchDate] = useState(0)
  const { user } = useUserAtom()
  const { sessionListUsers } = useSessionListUsers()

  const handleGetUserInfo = (targetId: string) => {
    if (targetId === String(user.id)) {
      return {
        session_name: user.nickname || '',
        session_avatar_url: user.avatar_url || ''
      }
    }
    return sessionListUsers?.find?.((friend) => friend.session_id === targetId)
  }

  useEffect(() => {
    const data = chatRecordsData?.list.filter((item) => {
      const content =
        typeof item.message_content === 'object'
          ? item.message_content.content
          : item.message_content
      return content?.indexOf?.(searchVal || '') !== -1
    })

    setShowData(data)
  }, [searchVal, chatRecordsData])

  return (
    <div className={styles.ChatRecords}>
      {/* 头部栏 */}
      <div className="header">
        <span className="c-white">Chat records</span>
        <a onClick={() => setChatRecords(false)}>
          <img src={DelSrc} width={18} />
        </a>
      </div>

      {/* 搜索栏 */}
      <div className="query-params">
        <div className="input-line">
          <Input
            value={searchVal}
            onChange={(e) => {
              setSearchVal(e.target.value)
            }}
          />
        </div>
        <DatePicker
          className="g-datePicker"
          placeholder=""
          suffixIcon={<img src={ArrowIcon} width={16} />}
          onChange={(value) => {
            setSearchDate(value?.valueOf() || 0)
          }}
        />
      </div>

      {/* 列表 */}
      <div className="list-box">
        {showDate?.map((item) => {
          if (item.message_type === EMessageType.TxtMsg) {
            return (
              <div className="list-item" key={item.created_at}>
                <div className="flx-justify-between mb10">
                  <Personal
                    size={'small'}
                    userData={item}
                    nickname={
                      handleGetUserInfo(item.sender_user_id)?.session_name
                    }
                    avatar={
                      handleGetUserInfo(item.sender_user_id)
                        ?.session_avatar_url || personal
                    }
                  />
                  <span className="f12 c-80">
                    {dayjs(item.created_at).format('YYYY-MM-DD')}
                  </span>
                </div>
                {/* 文字消息 */}
                <div className="message-text">
                  {item.message_content as string}
                </div>
              </div>
            )
          }

          if (item.message_type === EMessageType.ImgMsg) {
            return (
              <div className="list-item" key={item.created_at}>
                <div className="flx-justify-between mb10">
                  <Personal
                    size={'small'}
                    nickname={
                      handleGetUserInfo(item.sender_user_id)?.session_name
                    }
                    avatar={
                      handleGetUserInfo(item.sender_user_id)
                        ?.session_avatar_url || personal
                    }
                    userData={{}}
                  />
                  <span className="f12 c-80">
                    {dayjs(item.created_at).format('YYYY-MM-DD')}
                  </span>
                </div>
                {/* 图片消息 */}
                <img
                  src={item.message_content as string}
                  className="message-image"
                />
              </div>
            )
          }
          return null
        })}
        {/* 讨论消息 */}
        {/* <div className="list-item">
          <div className="flx-justify-between mb10">
            <Personal size={'small'} />
            <span className="f12 c-80">2023-11-15</span>
          </div>

          <div className="message-media">
            <img src={Discuss} width={50} />
            <div className="infos">
              <div className="c-white sle mb4">The Miserable World</div>
              <div className="f12 c-white sle mb10">The Miserable World</div>
              <div className="f10 c-80">Community</div>
            </div>
          </div>
        </div> */}

        {/* 视频消息 */}
        {/* <div className="list-item">
          <div className="flx-justify-between mb10">
            <Personal size={'small'} />
            <span className="f12 c-80">2023-11-15</span>
          </div>
          <div className="message-media">
            <img src={ImgSrc} width={50} />
            <img src={Play} width={30} className="play-icon" />
            <div className="infos">
              <div className="c-white sle mb4">The Miserable World</div>
              <div className="f12 c-white sle mb10">The Miserable World</div>
              <div className="f10 c-80">Video</div>
            </div>
          </div>
        </div> */}

        {/* 视频消息 */}
        {/* <div className="list-item">
          <div className="flx-justify-between mb10">
            <Personal size={'small'} />
            <span className="f12 c-80">2023-11-15</span>
          </div>

          <div className="message-media">
            <img src={ImgSrc} width={50} />
            <div className="infos">
              <div className="c-white sle mb4">The Miserable World</div>
              <div className="f12 c-white sle mb10">The Miserable World</div>
              <div className="f10 c-80">Story</div>
            </div>
          </div>
        </div> */}

        {/* 书单消息 */}
        {/* <div className="list-item">
          <div className="flx-justify-between mb10">
            <Personal size={'small'} />
            <span className="f12 c-80">2023-11-15</span>
          </div>

          <div className="message-media">
            <img src={StoryList} width={50} />
            <div className="infos">
              <div className="c-white sle mb4">The Miserable World</div>
              <div className="f12 c-white sle mb10">The Miserable World</div>
              <div className="f10 c-80">Community</div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}
